"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockBoatLanding = void 0;
const test_helpers_1 = require("../test_helpers");
function mockBoatLanding(overrides = {}) {
    return {
        access: 'Public',
        county: 'Ramsey',
        id: (0, test_helpers_1.incrementingId)(),
        lat: 45,
        lng: -75,
        name: 'mock_brand',
        state: 'MN',
        ...overrides,
    };
}
exports.mockBoatLanding = mockBoatLanding;
